import React from 'react';
import { BdsIntlProvider, type BdsMessages } from '@beeline.com/bp-design-system';
import { UdsIntlProvider as ReactUdsIntlProvider } from '@utmost.co/utmost-design-system/src/translations';
import { useFormatUdsMessage, useUdsMessages } from './translations/useUdsIntl';

export const DesignSystemsIntlProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const udsLocales = useUdsMessages();
  const format = useFormatUdsMessage();

  return (
    <BdsIntlProvider format={format} messages={udsLocales as BdsMessages}>
      <ReactUdsIntlProvider format={format} messages={udsLocales}>
        {children}
      </ReactUdsIntlProvider>
    </BdsIntlProvider>
  );
};
